module.exports = __webpack_public_path__ + "img/img15.3438547c.png";